import dayjs from "@/lib/dayjs";

type Props = {
	date: string;
	inc: number;
	format?: string;
};

/**
 *
 * @description 任意の日数を加算する
 *
 * @param {Props} props
 * @param {string} props.date - 加算対象の日付
 * @param {number} props.inc - 加算する日数
 * @param {format} props.format - フォーマット
 */
export function addDate({ date, inc, format = "YYYY-MM-DD" }: Props): string {
	return dayjs(date).add(inc, "day").format(format);
}
